import { useQuery } from "@tanstack/react-query";
import type React from "react";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/components/FullSizeLoader/FullSizeLoader";
import { documentMutations } from "@/queries/documents/mutations";
import { useDocumentQueries } from "@/queries/documents/queryOptions";

import type { LayoutProps } from "./Layout";

interface LoaderProps {
  children: (props: LayoutProps) => React.ReactNode;
}

export function Loader(props: LoaderProps): React.ReactNode {
  const documentQueries = useDocumentQueries();
  const { data = [], isLoading, error } = useQuery(documentQueries.listRoots());
  const { mutateAsync: deleteRootFolder } = documentMutations.useDeleteRootFolder();

  if (error) {
    return <ErrorPage error={error} />;
  }

  return isLoading ? (
    <FullSizeLoader withPadding />
  ) : (
    props.children({
      rootList: data,
      onDeleteFolder: deleteRootFolder,
    })
  );
}
